import { render, staticRenderFns } from "./material_requirement.vue?vue&type=template&id=12ded725&scoped=true&"
import script from "./material_requirement.vue?vue&type=script&lang=js&"
export * from "./material_requirement.vue?vue&type=script&lang=js&"
import style0 from "./material_requirement.vue?vue&type=style&index=0&id=12ded725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ded725",
  null
  
)

export default component.exports